import { render } from "./MenuStyle.vue?vue&type=template&id=cb9be4d4"
import script from "./MenuStyle.vue?vue&type=script&lang=js"
export * from "./MenuStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__